import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';

import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";
import Dropdowns from './dropdown';

import Model from './model';
import Section from './section';
import Set from './set';
import Category from './category';

class Categorisation extends Component {

  state = {
    data: [],
    load: false,
    message: '',
    cate: [],
    storeddata: [],
  }

  componentDidMount() {
    this.getCategory();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno) {
      this.getCategory();
    }
  }

  getCategory() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting category fields!!!'
    });
    let data1 = {'partno': this.props.partno};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getcategory.php',
      success: function(data)
      {
        data = JSON.parse(data);
        console.log(data);
        context.setState({
          cate: data,
          load: false
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    let { load, message } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div style={{padding: '1%'}}>
        <Card fluid>
          <Grid>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <Grid style={{padding: '2%'}}>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Model<br/>
                  <Model data={this.state.cate} partno={this.props.partno} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Group<br/>
                  <Section data={this.state.cate} partno={this.props.partno} />
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <Grid style={{padding: '2%'}}>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Category<br/>
                  <Category data={this.state.cate} partno={this.props.partno} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Assembly<br/>
                  <Set data={this.state.cate} partno={this.props.partno} />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </Card>
        {loading}
      </div>
    );
  }
}

export default Categorisation;
